import { useAuth } from "@clerk/clerk-react";
import Box from "@mui/material/Box";
import { grey } from "@mui/material/colors";
import { AlertContext } from "contexts/Alert";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "schemas/routes";

import StyledVaPage from "components/Styled/VAPage";
import BrandPreferencesSettings from "features/Influencer/VA/VASettings/GeneralSettings/BrandPreferences";
import { fetcherAuth } from "utils/api";
import { useTracking } from "utils/useTracking";

interface Props {
  finishSetUpLater: () => void;
}

const SelfServeVaBrandPreferences = ({ finishSetUpLater }: Props) => {
  const { getToken } = useAuth();
  const { setErrorAlert } = useContext(AlertContext);

  const { currentOrg, organizationVaProfile } = useContext(
    OrganizationUserContext,
  );
  const [loading, setLoading] = useState(false);
  const { trackVaStep } = useTracking();
  const navigate = useNavigate();

  const handleSubmitPreferences = async () => {
    try {
      setLoading(true);
      await fetcherAuth(
        getToken,
        `/api/organization/${currentOrg?.id}/va-settings`,
        "PUT",
        {},
        {
          openToGifted: organizationVaProfile?.openToGifted,
          openToAffiliates: organizationVaProfile?.openToAffiliates,
          openToForms: organizationVaProfile?.openToForms,
          openToSocial: organizationVaProfile?.openToSocial,
        },
      );
      navigate(`/${routes.emailWarmupSelfServeOnboarding}`);
      trackVaStep(routes.emailWarmupSelfServeOnboarding);
    } catch (error) {
      setErrorAlert(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <StyledVaPage
      stepNumber={4}
      title="Collab Preferences 💭"
      time="1"
      description={
        <>
          Let's customize how your virtual assistant reaches out to brands on
          your behalf.
          <br />
          You can always change this later in your dashboard
        </>
      }
      body={
        <Box
          sx={{
            border: `1px solid ${grey[300]}`,
            borderRadius: 3,
            p: 3,
            my: 3,
            maxWidth: 600,
          }}
        >
          <BrandPreferencesSettings />
        </Box>
      }
      onBack={() => {
        trackVaStep(routes.templatesSelfServeOnboarding);
        navigate(`/${routes.templatesSelfServeOnboarding}`);
      }}
      buttonBack={"Back"}
      buttonNext={"Continue to Email Warmup"}
      onNext={handleSubmitPreferences}
      onFinishSetUpLater={finishSetUpLater}
      loading={loading}
    />
  );
};

export default SelfServeVaBrandPreferences;
